/**
 * @generated SignedSource<<9cb6ec97b5d80f17cf95a2ad98f1f0a7>>
 * @relayHash 3e504c2a5cd0303a43a0d4f9f1731b08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c7d3d77866ff1cede55d066114d2d3a2ca66881db35990578af056b96d50101

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareFormAppQuery } from './JiraSoftwareFormAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareFormAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0c7d3d77866ff1cede55d066114d2d3a2ca66881db35990578af056b96d50101",
    "metadata": {},
    "name": "JiraSoftwareFormAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
